import { render, staticRenderFns } from "./previous-video-detail.vue?vue&type=template&id=73da4145&"
import script from "./previous-video-detail.vue?vue&type=script&lang=js&"
export * from "./previous-video-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports